import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Dimmer, Form, Header, Input, Loader } from 'semantic-ui-react';
import { HasWapFullLevel, HasWapUpdateLevel } from '../../containers/Authorization';
import { getAltAccountNumber } from '../../containers/Utils';
import CountrySelector from '../Countries';
import DateOfBirth from '../DateOfBirth';
import StateSelector from '../States';
import './styles.css';

let statusColor = 'status-color-active';

class ViewMember extends Component {
  static propTypes = {
    memberRequest: PropTypes.object,
    orderNewCard: PropTypes.func,
    setMemberRequest: PropTypes.func.isRequired,
    removeMemberRequest: PropTypes.func.isRequired,
    setSuccessMessage: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    setInfoMessage: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return null;
  }

  constructor(props) {
    super(props);
    if (isEmpty(props.memberRequest)) {
      this.state = {
        cancel: true,
        edit: false,
        renew: false,
      };
    } else {
      this.state = {
        member: props.memberRequest,
        cancel: false,
        edit: false,
        renew: false,
      };
      props.removeMemberRequest();
    }
  }

  orderCard = () => {
    const { orderNewCard, setSuccessMessage, setErrorMessage } = this.props;
    const { member } = this.state;
    this.setState({
      memberLoading: true,
      loadingMessage: 'Ordering Card...',
    });

    return orderNewCard({
      variables: {
        id: member.id,
      },
    })
      .then((response) => {
        this.setState({
          memberLoading: false,
          loadingMessage: undefined,
        });
        setSuccessMessage('New card ordered');
      })
      .catch((err) => {
        this.setState({
          memberLoading: false,
          loadingMessage: undefined,
        });
        setErrorMessage(err);
      });
  }

  handleCancel = () => {
    this.setState({
      cancel: true,
    });
  }

  handleEdit = () => {
    this.setState({
      edit: true,
    });
  }

  handleRenew = () => {
    this.setState({
      renew: true,
    });
  }

  parseAccountStatusToText = (inpAcctStatus) => {
    const strArrayAcctData = process.env.ACCOUNT_STATUS_DATA.split('|');
    let acctStatus;
    let acctStatusText;

    for (let i = 0; i < strArrayAcctData.length; i += 1) {
      const strArrayAcctDetails = strArrayAcctData[i].split(',');
      [acctStatus, acctStatusText] = strArrayAcctDetails;
      if (inpAcctStatus === acctStatus) {
        break;
      }
    }
    if (inpAcctStatus === '0') {
      statusColor = 'status-color-active';
    }
    if (inpAcctStatus === '4') {
      statusColor = 'status-color-cancel';
    }
    if (inpAcctStatus === '5') {
      statusColor = 'status-color-expire';
    }
    if (inpAcctStatus === 'D' || inpAcctStatus === 'M' || inpAcctStatus === 'U') {
      statusColor = 'status-color-suspend';
    }
    return acctStatusText;
  }

  disableEditButton = (inpAcctStatus) => {
    const accountStatusToEnableButton = ['0', '4', '5', 'M', 'U'];
    return (accountStatusToEnableButton.indexOf(inpAcctStatus) < 0);
  }

  disableRenewButton = (inpAcctStatus) => {
    const accountStatusToEnableButton = ['0', '4', '5'];
    return (accountStatusToEnableButton.indexOf(inpAcctStatus) < 0);
  }

  copyAccountNumber = (accountNumber) => {
    const { setInfoMessage } = this.props;
    navigator.clipboard.writeText(accountNumber);
    setInfoMessage(`Account Number ${accountNumber} copied to clipboard`);
  }

  render() {
    const {
      memberLoading, member, edit, cancel, renew, loadingMessage,
    } = this.state;

    const { setMemberRequest } = this.props;

    if (edit) {
      setMemberRequest({ ...member });
      return <Redirect to="/edit" />;
    }

    if (renew) {
      setMemberRequest({ ...member });
      return <Redirect to="/renew" />;
    }

    if (cancel) {
      return <Redirect to="/search" />;
    }

    let altAcctNumber = '';
    if (member.id !== undefined) {
      altAcctNumber = getAltAccountNumber(this.props, member.id);
    }

    member.dateOfBirth = member.birthMonth ? `${member.birthMonth}/${member.birthDay}/${member.birthYear}` : '';
    member.spouseDateOfBirth = member.spouseBirthMonth ?
      `${member.spouseBirthMonth}/${member.spouseBirthDay}/${member.spouseBirthYear}` : '';
    return (
      <div>
        <Dimmer.Dimmable as="div">
          {
            memberLoading &&
            <Dimmer active={memberLoading}>
              <Loader inverted>{loadingMessage || 'Loading Member...'}</Loader>
            </Dimmer>
          }
          <div styleName="details-container">
            <HasWapUpdateLevel>
              <Button
                styleName="action-button"
                type="button"
                content="Edit"
                onClick={this.handleEdit}
                disabled={this.disableEditButton(member.accountStatus)}
              />
              <HasWapFullLevel>
                <Button
                  styleName="action-button"
                  content="Renew"
                  type="button"
                  onClick={this.handleRenew}
                  disabled={this.disableRenewButton(member.accountStatus)}
                />
              </HasWapFullLevel>
              <Button
                styleName="action-button"
                type="button"
                content="Order Card"
                onClick={this.orderCard}
                disabled={member.accountStatus !== '0'}
              />
              <Button styleName="action-button" type="button" onClick={this.handleCancel}>Cancel</Button>
            </HasWapUpdateLevel>
            <Header as="h2" dividing styleName="view-header">
              Verify Member Information
              {
                member.expiryDate &&
                <Header.Subheader
                  styleName={statusColor}
                >
                  Your account is currently paid through {member.expiryDate} and is in <b><i>{this.parseAccountStatusToText(member.accountStatus)}</i></b> status {/* eslint-disable-line max-len */}
                </Header.Subheader>
              }
              {
                member.autoRenew === 'Y' &&
                <Header.Subheader>
                  Member is currently using Auto Renew
                </Header.Subheader>
              }
              {
                member.autoRenew !== 'Y' &&
                <Header.Subheader>
                  Member is currently not using Auto Renew
                </Header.Subheader>
              }
            </Header>
            <Form size="small">
              <div styleName="member-info">
                <Form.Group>
                  <Form.Field
                    control={Input}
                    label="Membership Number"
                    value={member.id}
                    name="membershipNumber"
                    readOnly
                  />
                  <Form.Field
                    control={Input}
                    label="Membership Type"
                    value={member.accountIndicator === 'N' ? 'NRTA' : 'AARP'}
                    name="accountIndicator"
                    readOnly
                    key="accountIndicator"
                    styleName="member-type"
                  />
                  <Form.Field
                    control={Input}
                    label="Card Sent Date (MM/DD/YYYY)"
                    value={member.cardSentDate}
                    name="cardSentDate"
                    readOnly
                    key="cardSentDate"
                  />
                </Form.Group>
                <div>
                  {
                    altAcctNumber !== '' ?
                      <Form.Group>
                        <Form.Field label="For AARP Medicare Supplement Insurance Applications, use this Number" control={Input}>
                          <Form.Field
                            control={Input}
                            value={altAcctNumber}
                            name="altAccountNumber"
                            readOnly
                          />
                          <Button
                            styleName="copy-button"
                            type="button"
                            onClick={() => { this.copyAccountNumber(altAcctNumber); }}
                          >
                            Copy Number
                          </Button>
                        </Form.Field>
                      </Form.Group>
                      : null
                  }
                </div>
                <Form.Group>
                  <Form.Field
                    control={Input}
                    label="First Name"
                    value={member.firstName}
                    name="firstName"
                    width="5"
                    readOnly
                    fluid
                  />
                  <Form.Field
                    control={Input}
                    label="Middle Name"
                    value={member.middleName}
                    name="middleName"
                    width="5"
                    readOnly
                    fluid
                  />
                  <Form.Field
                    control={Input}
                    label="Last Name"
                    value={member.lastName}
                    name="lastName"
                    width="5"
                    readOnly
                    fluid
                  />
                </Form.Group>
                <DateOfBirth
                  member={member}
                  readOnly
                  memberLevel="primary"
                />
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="Mailing Address"
                    value={member.addressLine1}
                    name="addressLine1"
                    readOnly
                    fluid
                  />
                  <Form.Field
                    control={Input}
                    label="Address (line 2)"
                    value={member.addressLine2}
                    name="addressLine2"
                    readOnly
                    fluid
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Field
                    control={Input}
                    label="City"
                    value={member.city}
                    name="city"
                    readOnly
                    width="4"
                  />
                  <StateSelector
                    member={member}
                    width="4"
                    readOnly
                  />
                  <Form.Field
                    control={Input}
                    label="Zip/Postal Code"
                    value={member.zipCode}
                    name="zipCode"
                    readOnly
                    width="4"
                  />
                </Form.Group>
                <CountrySelector
                  member={member}
                  readOnly
                  width="4"
                />
                <Form.Field
                  control={Input}
                  label="Phone"
                  value={member.phoneNumber}
                  name="phoneNumber"
                  readOnly
                  width="4"
                />
                <Form.Field
                  control={Input}
                  label="Email Address"
                  value={member.emailAddress}
                  name="emailAddress"
                  readOnly
                  width="12"
                />
              </div>
              <div styleName="member-info spouse-info">
                <Header as="h3" dividing>
                  Spouse/Partner Information
                </Header>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="First Name"
                    value={member.spouseFirstName}
                    name="spouseFirstName"
                    readOnly
                    fluid
                  />
                  <Form.Field
                    control={Input}
                    label="Middle Name"
                    value={member.spouseMiddleName}
                    name="spouseMiddleName"
                    readOnly
                    fluid
                  />
                  <Form.Field
                    control={Input}
                    label="Last Name"
                    value={member.spouseLastName}
                    name="spouseLastName"
                    readOnly
                    fluid
                  />
                </Form.Group>
                <Form.Group>
                  <DateOfBirth
                    member={member}
                    readOnly
                    memberLevel="spouse"
                  />
                  <Form.Field
                    control={Input}
                    label="Email Address"
                    value={member.spouseEmailAddress}
                    name="spouseEmailAddress"
                    readOnly
                    width="12"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Dimmer.Dimmable>
      </div>
    );
  }
}

export default ViewMember;



// WEBPACK FOOTER //
// ./src/app/components/ViewMember/index.js